// leaseViewClient — the staff "view a lease" page's API (routes/leaseView.ts).
// Authenticated through the shared `api` helper like every staff call.

import { api } from './api';
import type { ReviewSummary } from './signClient';

export type LeaseViewState = 'draft' | 'in_progress' | 'executed' | 'declined' | 'cancelled';

export interface LeaseViewVersion {
  /** For the URL (?version=) only — never rendered. */
  versionId: string;
  /** "Version 3". */
  label: string;
  generatedAt: string;
  sent: boolean;
  state: LeaseViewState;
  stateLabel: string;
}

export interface LeaseViewHeader {
  propertyAddress: string | null;
  residentNames: string | null;
  /** yyyy-mm-dd. */
  termStart: string | null;
  termEnd: string | null;
  statusLabel: string;
  isRenewal: boolean;
}

export interface LeaseViewResponse {
  header: LeaseViewHeader | null;
  versions: LeaseViewVersion[];
  selectedVersionId: string | null;
  defaultVersionId: string | null;
  summary: ReviewSummary | null;
  document: { path: string; filename: string } | null;
  builderPath: string;
}

export function getLeaseView(groupId: string, versionId?: string | null): Promise<LeaseViewResponse> {
  const q = versionId ? `?version=${encodeURIComponent(versionId)}` : '';
  return api.get(`/api/leases/${encodeURIComponent(groupId)}${q}`);
}

/** The selected version's PDF bytes (bounded, PDF-only server-side). */
export function fetchLeaseDocument(path: string): Promise<Blob> {
  return api.blob(path, 'application/pdf');
}
